import React from 'react';
import { programs } from '../../data/programs';
import { site, socials } from '../../data/site';
import { Container } from '../ui/Container';
import { SocialIcon } from '../ui/SocialIcon';
import { programPaths, schoolLinks } from '../../data/navigation';
const headingClass = 'text-sm font-semibold uppercase tracking-[0.12em] text-white/55';
const linkClass = 'inline-flex min-h-[40px] items-center text-[15px] text-white/80 transition-colors duration-150 hover:text-white';
const footerSchoolLinks = [{
  label: 'Class schedule',
  href: '/schedule'
}, {
  label: 'Our coaches',
  href: '/instructors'
}, ...schoolLinks.filter(link => link.href !== '/more' && link.href !== '/free-trial-class')];
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark bg-black text-white" data-id="element-373" data-mp="3e2me0bdbvmiw">
      <Container className="grid gap-10 py-16 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)_minmax(0,1.3fr)_minmax(0,0.85fr)] lg:gap-8" data-id="element-374" data-mp="3e2ckidt2qx8g">
        <div className="min-w-0" data-id="element-375" data-mp="2kcl4nccg0rxr">
          <a href="/" className="inline-flex items-center gap-4" data-id="element-376" data-mp="2kcbenoreeks2">
            <img src={site.logo} alt="" className="h-24 w-auto" loading="lazy" data-id="element-377" data-mp="2p4cybvqwbds4" />
            <span className="font-display text-[1.75rem] font-bold uppercase leading-[0.95] tracking-wide" data-id="element-378" data-mp="2bcexe87c8o71">
              Bates
              <br data-id="element-379" data-mp="2gaq78ixmuyp9" />
              Taekwondo
            </span>
          </a>
          <address className="mt-5 not-italic text-[15px] leading-relaxed text-white/80" data-id="element-380" data-mp="341der33mzmba">
            {site.street}
            <br data-id="element-381" data-mp="382yzfamex4w1" />
            {site.cityLine}
          </address>
          <ul className="mt-2" data-id="element-382" data-mp="380crvaziupdt">
            <li data-id="element-383" data-mp="2u3pig8qdu6r0">
              <a href={site.directionsUrl} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-384" data-mp="2u24nwj42int5">
                Get directions<span className="sr-only" data-id="element-385" data-mp="2z067r69bir5o"> (opens in a new tab)</span>
              </a>
            </li>
            <li data-id="element-386" data-mp="1img3nzi782w1">
              <a href={site.phoneHref} className={linkClass} data-id="element-387" data-mp="1iq3ugqw9eb72">
                {site.phoneDisplay}
              </a>
            </li>
            <li data-id="element-388" data-mp="13kzfeoked6xy">
              <a href={site.emailHref} className={linkClass} data-id="element-389" data-mp="13joeqxm90fb2">
                {site.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="min-w-0" data-id="element-390" data-mp="usfpcci68aoq">
          <h2 className={headingClass} data-id="element-391" data-mp="urmht9be1h5j">Programs</h2>
          <ul className="mt-3" data-id="element-392" data-mp="uq2wh4avkfww">
            {programs.map(p => <li key={p.id} data-id="element-393" data-mp="pstbc0uiqqev">
                <a href={programPaths[p.id]} className={linkClass} data-id="element-394" data-mp="pri6dxpc7cm6">
                  {p.name}
                </a>
              </li>)}
            <li data-id="element-395" data-mp="fu3ri2j2avvz">
              <a href="/free-trial-class" className={linkClass} data-id="element-396" data-mp="ftlngjq5rddi">
                Free trial class
              </a>
            </li>
          </ul>
        </div>

        <div className="min-w-0" data-id="element-397" data-mp="6v07mwc2mcgf">
          <h2 className={headingClass} data-id="element-398" data-mp="6vs1a1m3y042">School information</h2>
          <ul className="mt-3" data-id="element-399" data-mp="2684d36391dql">
            {footerSchoolLinks.map(link => <li key={link.href} data-id="element-400" data-mp="265i2syoz4k4o"><a href={link.href} className={linkClass} data-id="element-401" data-mp="218hx4ow1dje3">{link.label}</a></li>)}
          </ul>
        </div>

        <div className="min-w-0" data-id="element-402" data-mp="28saeb60haq3g">
          <h2 className={headingClass} data-id="element-403" data-mp="28qz9d2varcar">Follow Bates</h2>
          <ul className="mt-3" data-id="element-404" data-mp="2dr3tr3zbsr69">
            {socials.map(s => <li key={s.name} data-id="element-405" data-mp="2dp9adu3pd74a">
                <a href={s.href} target="_blank" rel="noopener noreferrer" className={`${linkClass} gap-3`} data-id="element-406" data-mp="2ii2csbbp83d7">
                  <SocialIcon name={s.name} className="h-[18px] w-[18px]" data-id="element-407" data-mp="2nhey2rmx92do" />
                  {s.label}
                  <span className="sr-only" data-id="element-408" data-mp="1ptob9lleioww"> (opens in a new tab)</span>
                </a>
              </li>)}
          </ul>
        </div>
      </Container>
      <div className="border-t border-white/10" data-id="element-409" data-mp="1uu2m1bee0cym">
        <Container className="flex flex-col gap-2 py-6 text-sm text-white/55 sm:flex-row sm:justify-between" data-id="element-410" data-mp="1zq9i8cgzea3d">
          <p data-id="element-411" data-mp="23tpdp5hbe4eh">© {year} Bates Taekwondo. All rights reserved.</p>
          <p data-id="element-412" data-mp="3b70wvdzdtfl5">
            {site.street}, {site.cityLine}
          </p>
        </Container>
      </div>
    </footer>;
}